import {downloadFile} from '@domain/file-download'
import {spawnErrorToast} from '@hm/fundamental'
import {useMutation} from '@tanstack/react-query'
import moment from 'moment-timezone'
import {useTranslation} from 'react-i18next'

import {downloadCostLeadershipExcel} from '../../common/backend/actions'
import {FEATURE_NAMESPACE} from '../../consts'

export const useCostLeadershipDownload = (plantId: string) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return useMutation({
    mutationFn: () => downloadCostLeadershipExcel(plantId),
    onSuccess: (blob: Blob) => {
      downloadFile(blob, `${moment().format('YYYY-MM-DD')}_${plantId}_cost-leadership.xlsx`)
    },
    onError: () => {
      spawnErrorToast(t('errors.costLeadershipDownloadFailed'))
    }
  })
}
